package gr.tech.GRAttestation.models.attestation

import gr.tech.GRAttestation.models.skus.SkuPreviewDTO
import gr.tech.GRAttestation.util.todayString
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import kotlin.random.Random

@Serializable
data class SalesData(
    @Transient val id: Int = Random.nextInt(),
    val quantity: Int = 0,
    val skuModel: SkuPreviewDTO = SkuPreviewDTO(
        id = -1,
        sku = "",
        description = "",
        unitPrice = 0L,
        amountPerReceipt = 0,
    ),
    val dateOfSale: String = todayString,
)
